import React from "react";

const Header = () => {
  return (
    <div className="">
      <h1 className="text-white text-2xl font-bold tracking-widest">
        TODO LIST
      </h1>
    </div>
  );
};

export default Header;
